export const DISCOUNT_PRODUCT_BY_CATEGORY_REQUEST = 'DISCOUNT_PRODUCT_BY_CATEGORY_REQUEST'
export const DISCOUNT_PRODUCT_BY_CATEGORY_SUCCESS = 'DISCOUNT_PRODUCT_BY_CATEGORY_SUCCESS'
export const DISCOUNT_PRODUCT_BY_CATEGORY_FAIL    = 'DISCOUNT_PRODUCT_BY_CATEGORY_FAIL'
export const DISCOUNT_PRODUCT_BY_CATEGORY_RESET = 'DISCOUNT_PRODUCT_BY_CATEGORY_RESET'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'